import './NotificationFlyout.css'
import '../PopUp.css'
import { useContext } from 'react';
import { AdminContext } from '../../contexts/AdminContext';
import { NotificationObject } from '../../interfaces/APIInterface';
import { isNullUndefEmpty } from '../../ts/common';
import Button from '@mui/material/Button';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";

interface NotificationFlyoutProps {
    viewNotification: boolean,
    setViewNotification: React.Dispatch<React.SetStateAction<boolean>>,
    note: NotificationObject,
    acknowledgeNotification: (notificationId: string, notificationApplication: string) => Promise<void>,
    userRedirect: (navigateTo: {pathname: string, search: string}) => void
}

const NotificationFlyout = (props: NotificationFlyoutProps) => {
    
    const {adminCredentials, getToken} = useContext(AdminContext);
    const isEmailRegex = /^[^@]+@[^@]+\.[^@]+$/;

    const handleAck = (id: string, applicationId: string) => {
        props.setViewNotification(false);
        props.acknowledgeNotification(id, applicationId);
    }

    const handleCancel = () => {
            props.setViewNotification(false);
    }


    return (
            <Dialog onClose={handleCancel} open={props.viewNotification} fullWidth maxWidth='lg'>
                <DialogTitle>
                    Error | {props.note.notificationType}
                </DialogTitle>
                <DialogContent>
                        <Typography variant='h6'> {props.note.id} </Typography>
                        <Typography variant='body1'> Application: {adminCredentials.allApplications[props.note.applicationId]?.name} </Typography>
                        {props.note.userId === undefined && props.note.userId === '' ? <></>:
                        !isEmailRegex.test(props.note.userId) ? 
                        <Typography variant='body1'>User: <Button className='link-imitation' onClick={() => props.userRedirect({pathname: `/edit-user`, search: `?user=${props.note.userId}&country=${props.note.country}`})}>{!isNullUndefEmpty(props.note.userEmail) ? props.note.userEmail : !isNullUndefEmpty(props.note.userFirstName) && !isNullUndefEmpty(props.note.userLastName) ? props.note.userFirstName + ' ' + props.note.userLastName : props.note.userId}</Button></Typography> : 
                        <Typography variant='body1'>Email Address: <Button className='link-imitation' onClick={() => props.userRedirect({pathname: `/search-users`, search: `?email=${props.note.userId}`})}>{props.note.userId}</Button></Typography>}
                        <Typography variant='body1'> Time: {new Date(props.note.tsCreatedAt * 1000).toLocaleString()} </Typography>
                        <br/>
                        <Typography variant='body1'> {props.note.notificationMessage} </Typography>
                </DialogContent>
                <DialogActions>
                    {props.note.adminAcknowledged ?
                        null
                        : <Button variant='outlined' onClick={() => handleAck(props.note.id, props.note.applicationId)}>
                            Acknowledge
                        </Button>
                    }
                </DialogActions>
            </Dialog>
    )
}

export default NotificationFlyout